import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Reveal from "@/components/Reveal";

// Reusable inner-page hero: eyebrow + heading + intro copy + optional
// breadcrumb trail. Left-aligned per the editorial rhythm guidelines.
const PageHero = ({ eyebrow, heading, intro, breadcrumb, minHeight = "44vh" }) => {
  return (
    <section
      className="relative flex items-center overflow-hidden px-6 md:px-0 pt-32 pb-20"
      style={{ minHeight }}
      data-testid="page-hero"
    >
      <div className="relative z-10 page-shell w-full">
        <div className="max-w-3xl">
          {breadcrumb && breadcrumb.length > 0 && (
            <nav aria-label="Breadcrumb" className="flex items-center gap-2 mb-6 flex-wrap">
              {breadcrumb.map((crumb, idx) => (
                <span key={crumb.label} className="flex items-center gap-2">
                  {idx > 0 && <ChevronRight size={12} className="text-[color:var(--gg-muted-text)]" />}
                  {crumb.to ? (
                    <Link to={crumb.to} className="text-small link-quiet" data-testid={`breadcrumb-${idx}`}>
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="text-small" data-testid={`breadcrumb-${idx}`}>{crumb.label}</span>
                  )}
                </span>
              ))}
            </nav>
          )}
          {eyebrow && <span className="eyebrow block mb-5" data-testid="page-hero-eyebrow">{eyebrow}</span>}
          <Reveal as="h1" className="text-h1" delay={80}>
            <span data-testid="page-hero-heading">{heading}</span>
          </Reveal>
          {intro && (
            <Reveal delay={160}>
              <p className="text-editorial mt-7" data-testid="page-hero-intro">{intro}</p>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
